<template>
  <modal :is-active="true" @close="close" :title="t('configurator.modals.titles.add_lettering')">
    <template #body>
      <div class="form-horizontal" id="mandatoryForm" style="min-height: 480px;">
        <div v-if="scheme" class="form-group row">
          <div class="col text-center">
            <img :src="scheme.public_path" style="height: 200px; width: auto;">
          </div>
        </div>

        <template v-if="forms.length > 0">
          <MandatoryBoothRefinementForm v-for="availableRefinement,index in availableRefinements"  
            :key="availableRefinement.id"
            :index="index"
            :form="forms[index]"
            :refinement="availableRefinement"
            />
        </template>

        <div class="form-group text-center mt-4">
          <button type="button" class="btn btn-warning mr-2" @click.prevent="close">
            {{ $t('configurator.buttons.cancel') }}
          </button>
          <button type="button" class="btn btn-primary" @click.prevent="submit">
            {{ $t('configurator.buttons.add') }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import Form from '@/classes/Form'
import { computed, watch, onMounted, ref } from 'vue'
import { useMainStore } from '@/store'
import { useI18n } from 'vue-i18n'
import MandatoryBoothRefinementForm from './MandatoryBoothRefinementForm.vue'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define props
const props = defineProps({
  availableRefinements: {
    type: Array,
    default: [],
  },
})
// define emits
const emit = defineEmits(['close', 'submit'])
// reactive props
const forms = ref([])
// define computed
const shoppingCart = computed(() => store.settings.shopping_cart)

const scheme = computed(() => {
  if (shoppingCart.value.booth.schemes.length === 0) {
    return null
  }

  const matchingScheme = shoppingCart.value.booth.schemes
    .filter((scheme) => {
      return scheme.booth_type === shoppingCart.value.booth_type.type
    })
    .find((scheme) => {
      return (
        parseFloat(scheme.width) === parseFloat(shoppingCart.value.width)
        && parseFloat(scheme.depth) === parseFloat(shoppingCart.value.depth)
      )
    })

  return (matchingScheme === undefined) ? null : matchingScheme
})
// define methods
const close = () => emit('close')

const submit = async () => {
  let errorsCount = 0
  await forms.value.forEach((form) => {
    form.errors.clear()
    
    let errors = {}
    if (form.article === null) {
      errors['article'] = t('configurator.form.errors.print_article')
      errorsCount += 1
    }

    if (form.article !== null && !form.is_logo_print && form.label.trim().length === 0) {
      errors['label'] = t('configurator.form.errors.lettering')
      errorsCount += 1
    }
    if (Object.keys(errors).length > 0) {
      form.errors.record({ errors: errors })
    }

    if (form.is_logo_print) {
      form.spanning_mode = { name: t('configurator.form.labels.print_per_surface'), value: false }
    } else {
      form.spanning_mode = { name: t('configurator.form.labels.lettering_per_surface'), value: false }
    }
  })

  if (errorsCount > 0) {
    return
  }

  emit('submit', forms.value)
}

onMounted(() => {
  props.availableRefinements.forEach((availableRefinement) => {
    forms.value.push(new Form({
      refinement: null, // deprecated
      refinements: [availableRefinement],
      is_logo_print: false,
      is_seamless_print: false,
      spanning_mode: null,
      label: '',
      article: null,
      file: null
    }))
  })
})
</script>

<style lang="scss">
#mandatoryForm .form-group {
  margin-bottom: 4px;
}
</style>